var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVipLoungeServiceTelephone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.886 15.654L15.664 14.876C15.82 14.72 15.82 14.466 15.664 14.31L13.062 11.708C12.906 11.552 12.652 11.552 12.496 11.708L12 12.202C11.844 12.358 11.59 12.358 11.434 12.202L7.74399 8.51402C7.58799 8.35802 7.58799 8.10402 7.74399 7.94802L8.23598 7.45602C8.39198 7.30002 8.39198 7.04602 8.23598 6.89002L5.63199 4.28601C5.47599 4.13001 5.22199 4.13001 5.06599 4.28601L4.29199 5.06001L3.60799 5.74401L3.586 5.76601C2.804 6.54801 2.804 7.81402 3.586 8.59402L11.364 16.372C12.146 17.1541 13.412 17.1541 14.192 16.372L14.9 15.664L14.886 15.654Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.468 7.94001H12.06V5.532C12.06 5.392 12.004 5.256 11.904 5.158C11.57 4.82399 10.998 5.06 10.998 5.532V9.00001H14.466C14.938 9.00001 15.176 8.42801 14.842 8.09401C14.744 7.99601 14.61 7.94001 14.468 7.94001Z",
    fill: "#FFC629"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.06 8.64602L11.354 7.94002L15.244 4.05002C15.44 3.85402 15.756 3.85402 15.952 4.05002C16.148 4.24602 16.148 4.56202 15.952 4.75802L12.06 8.64602Z",
    fill: "#FFC629"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipLoungeServiceTelephone);
export default __webpack_public_path__ + "static/media/vip-lounge-service-telephone.680ef3a9816c2001c6b34ba9c3cf3d85.svg";
export { ForwardRef as ReactComponent };